const ScrollPrompt = ({ onClick }) => (
    <div className="floating-text" onClick={onClick}>
      What is Imazen?
    </div>
  );
  
  export default ScrollPrompt;
  